<style scoped>
.params {
  max-width: 437px !important;
}

.params-checkbox {
  margin-top: 6px !important;
}

.params-checkbox >>> .v-label {
  font-size: 14px !important;
}

.params-header {
  padding: 8px;
}

.params-body {
  margin-top: 8px;
  background-color: white;
  padding: 12px;
}

.datepicker-container {
  min-width: 125px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>

<template>
  <div class="d-flex">
    <v-spacer />
    <div class="d-flex">
      <slot name="preppend" />
      <v-card flat outlined class="params">
        <div class="params-header d-flex gray-bg">
          <v-btn
            :class="[{secondary : selectedButton === buttonsMap.seven}, 'mx-1', 'flex-grow-1']"
            small
            depressed
            @click="() => setParams(7, buttonsMap.seven)"
          >
            Past 7 Days
          </v-btn>
          <v-btn
            :class="[{secondary : selectedButton === buttonsMap.thirty}, 'mx-1', 'flex-grow-1']"
            small
            depressed
            @click="() => setParams(30, buttonsMap.thirty)"
          >
            Past 30 Days
          </v-btn>
          <v-btn
            :class="[{secondary : selectedButton === buttonsMap.all}, 'mx-1', 'flex-grow-1']"
            small
            depressed
            @click="() => setParams(null, buttonsMap.all)"
          >
            All Time
          </v-btn>
          <v-btn
            depressed
            small
            class="mx-1 flex-grow-1"
            color="primary"
            :disabled="!valid"
            @click="$emit('submit', value)"
          >
            {{ submitText }}
          </v-btn>
        </div>
        <v-divider />
        <div class="params-body">
          <v-form ref="form" v-model="valid">
            <slot name="form">
              <v-row>
                <v-col class="datepicker-container">
                  <anchor-date-picker-input
                    v-model="value.startDate"
                    append-icon="mdi-calendar"
                    :prependIcon="null"
                    label="From"
                    :max-date="this.value.endDate || this.today"
                    :rules="noValidation ? [] : rules.startDate"
                  />
                </v-col>
                <v-col class="datepicker-container">
                  <anchor-date-picker-input
                    v-model="value.endDate"
                    label="To"
                    append-icon="mdi-calendar"
                    :prependIcon="null"
                    :min-date="this.value.startDate"
                    :max-date="today"
                    :rules="noValidation ? [] : rules.endDate"
                  />
                </v-col>
              </v-row>
            </slot>
          </v-form>
        </div>
        <slot />
      </v-card>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import MODEL from '../../resources/js/search/params/model';
import RULES from '../../resources/js/search/params/rules';

export default {
  props: {
    noValidation: Boolean,
    submitText: {
      type: String,
      default: 'Submit',
    },
    value: {
      type: Object,
      default: () => JSON.parse(JSON.stringify(MODEL)),
    },
  },
  data: () => ({
    rules: RULES,
    today: new Date(),
    valid: false,
    buttonsMap: {
      seven: '7Days',
      thirty: '30Days',
      all: 'allTime',
    },
    selectedButton: null,
  }),
  methods: {
    setParams(dayDiff, buttonName) {
      this.selectedButton = buttonName;
      let params = {
        endDate: new Date(),
        startDate: new Date(null),
        selectedButton: this.selectedButton,
        selectedValue: dayDiff,
      };
      if (dayDiff) {
        const dt = DateTime.local();
        params = {
          endDate: dt.toJSDate(),
          startDate: dt.minus({ days: dayDiff }).toJSDate(),
          selectedButton: this.selectedButton,
          selectedValue: dayDiff,
        };
      }

      this.$emit('input', params);
    },
  },
};
</script>
